export default {
	firestorePath: "content",
	firestoreRefType: "collection",
	moduleName: "content",
	statePropName: "data",
	namespaced: true,
	state: {},
	getters: {
	},
	mutations: {},
	actions: {
	},
};
